<div class="footer p-2">
  <div class="row justify-content-center">
    <!-- <div class="col-lg-2 col-md-2 col-sm-4 col-4 pl-0 pr-0 text-right">
      <span class="cursor-pointer text-white" (click)="contactUs.openForm()">Contact Us</span>
    </div> -->
    <div class="col text-center">
      <!-- <a class=" text-white" href="#">© Conexio 2019</a> -->
      <a class=" text-white" href="#" (click)="goToLink('#')">© NissanConnect Commercial {{currentYear}}</a>
    </div>
  </div>
</div>

<app-contact-us #contactUs></app-contact-us>